<template>
  <div class="SurveyPageContainer">
        <account :params="params">
            <a-tab v-for="(tab, i) in params.tabs" :key="i" :name="i">
                <ReviewsListSection title="" :list-data="params.reviews"/>
            </a-tab>
            <template #aside>
                <ActionCard :data="params?.company">
                    <template #footer>
                        <div class="flex between borderedCard">
                            <div>
                                <span>450</span>
                                <span>Выделено часов</span>
                            </div>
                            <div>
                                <span>10</span>
                                <span>Проектов</span>
                            </div>
                        </div>
                    </template>
                </ActionCard>

                <aside-nav v-if="params?.menu" :items="params?.menu"/>
            </template>
        </account>
    </div>
</template>

<script>
import {AInput, ABtn, ATab} from "../components/ui";
import ARadioButtonGroup from "../components/ui/ARadioButtonGroup";
import Account from "../components/sections/Account";
import ActionCard from "../components/cards/ActionCard";
import ReviewsListSection from "../components/sections/ReviewsListSection";
import AsideNav from "../components/AsideNav";

export default {
    name: "ReviewsPageContainer",

    props: ['params'],

    components: {
        AsideNav,
        ReviewsListSection,
        ActionCard,
        Account,
        ARadioButtonGroup,
        AInput, ABtn, ATab
    },

    setup() {
        const formSend = () => {
        }

        const setError = (field, res) => {
            field.error = res;
        };

        const buttonAction = (field) => {
        }

        return {
            formSend,
            setError
        }
    }
}
</script>

<style scoped lang="scss">

::v-deep .account {
    margin-top: -100px;


    &__nav {
        @include tablet {
            display: none;
        }
    }

    &__body::before {
        content: unset;
    }

    @include mobile {
        margin-top: 0;
    }
}
</style>